export const SIGNUP_ACTIVITY_LIST = {
	name: "活动登记应用 - 活动列表",
	api: '${APP_ACTIVITY_SIGNUP}/app-activity-registration/activity/list',
	method: "post",
	doc: "http://192.168.15.26:8198/app-activity-registration/doc.html"
}

export const SIGNUP_ACTIVITY_INFO = {
	name: "活动登记应用 - 活动详情",
	api: '${APP_ACTIVITY_SIGNUP}/app-activity-registration/activity/simple/detail',
	doc: "http://192.168.15.26:8198/app-activity-registration/doc.html"
}

export const SIGNUP_ACTIVITY_MEMBER_INFO = {
	name: "活动登记应用 - 根据会员卡号查询会员信息",
	api: '${APP_ACTIVITY_SIGNUP}/app-activity-registration/activity/registration/select/member/info',
	method: "post",
	doc: "http://192.168.15.26:8198/app-activity-registration/doc.html"
}

export const SIGNUP_ACTIVITY_MEMBER_JOIN = {
	name: "活动登记应用 - 会员确认登记",
	api: '${APP_ACTIVITY_SIGNUP}/app-activity-registration/activity/registration/confirm',
	method: "post",
	doc: "http://192.168.15.26:8198/app-activity-registration/doc.html"
}
export const SIGNUP_ACTIVITY_GRADE_RULE = {
	name: "活动登记应用 - 获取活动卡规则信息",
	api: '${APP_ACTIVITY_SIGNUP}/app-activity-registration/activity/grade/rule',
	method: "get",
	doc: "http://192.168.15.26:8198/app-activity-registration/doc.html#/%E6%B4%BB%E5%8A%A8%E7%99%BB%E8%AE%B0%E5%BA%94%E7%94%A8/%E6%B4%BB%E5%8A%A8%E7%9B%B8%E5%85%B3%E6%8E%A5%E5%8F%A3/selectActivityRuleUsingGET"
}